import { render, staticRenderFns } from "./MMyExchange.vue?vue&type=template&id=5e2b40e0&"
import script from "./MMyExchange.vue?vue&type=script&lang=js&"
export * from "./MMyExchange.vue?vue&type=script&lang=js&"
import style0 from "./MMyExchange.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports